export default __webpack_public_path__ + "static/media/rafael.f295c642.png";